import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PendingScreen from "@/pages/PendingScreen";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import NewAppointment from "@/pages/NewAppointment";
import AppointmentsList from "@/pages/AppointmentsList";
import AppointmentDetail from "@/pages/AppointmentDetail";
import Approvals from "@/pages/Approvals";
import Catalogs from "@/pages/Catalogs";
import DatabaseView from "@/pages/DatabaseView";
import RechazosList from "@/pages/RechazosList";
import NewRechazo from "@/pages/NewRechazo";
import RechazoDetail from "@/pages/RechazoDetail";
import RecoleccionesList from "@/pages/RecoleccionesList";
import NewRecoleccion from "@/pages/NewRecoleccion";
import RecoleccionDetail from "@/pages/RecoleccionDetail";
import { InstallPrompt } from "@/components/InstallPrompt";
import "@/App.css";

function Protected({ children, admin, perm }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505] text-white/60">
        Cargando…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (perm && !(user.permissions || []).includes(perm)) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App dark noise-bg min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pending" element={<PendingScreen />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="citas/nueva" element={
                <Protected perm="appointments:create">
                  <NewAppointment />
                </Protected>
              } />
              <Route path="citas" element={<AppointmentsList />} />
              <Route path="citas/:id" element={<AppointmentDetail />} />
              <Route path="base-de-datos" element={<DatabaseView />} />
              <Route path="rechazos" element={<RechazosList />} />
              <Route path="rechazos/nuevo" element={
                <Protected perm="evidence:write">
                  <NewRechazo />
                </Protected>
              } />
              <Route path="rechazos/:id" element={<RechazoDetail />} />
              <Route path="recolecciones" element={<RecoleccionesList />} />
              <Route path="recolecciones/nueva" element={
                <Protected perm="appointments:create">
                  <NewRecoleccion />
                </Protected>
              } />
              <Route path="recolecciones/:id" element={<RecoleccionDetail />} />
              <Route
                path="admin/aprobaciones"
                element={
                  <Protected admin>
                    <Approvals />
                  </Protected>
                }
              />
              <Route
                path="admin/catalogos"
                element={
                  <Protected admin>
                    <Catalogs />
                  </Protected>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <InstallPrompt />
      </AuthProvider>
    </div>
  );
}

export default App;
